import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface DashboardHeaderProps {
  actions?: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({actions, breadcrumbs = []}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    if (breadcrumbs.length > 0) return breadcrumbs;

    const path = location.pathname;
    if (path.includes('opportunities'))
      return [
        {label: 'Dashboard', path: '/dashboard'},
        {label: 'Opportunities', path: '/opportunities'},
      ];
    if (path === '/dashboard') return [{label: 'Dashboard', path: '/dashboard'}];
    if (path === '/settings')
      return [
        {label: 'Dashboard', path: '/dashboard'},
        {label: 'Settings', path: '/settings'},
      ];
    return [{label: 'Dashboard', path: '/dashboard'}];
  };

  const currentBreadcrumbs = getBreadcrumbs();

  return (
    <div className="pl-20 pr-4 sticky top-0 z-20 flex h-14 w-full items-center gap-3 border-b border-gray-200 bg-white py-2.5">
      <div className="px-2 flex flex-1 items-center overflow-hidden">
        {currentBreadcrumbs.map((crumb, index) => {
          const isLast = index === currentBreadcrumbs.length - 1;
          return (
            <React.Fragment key={index}>
              <button
                disabled={isLast || !crumb.path}
                onClick={() => crumb.path && navigate(crumb.path)}
                className={`text-sm font-medium leading-tight transition-colors ${
                  isLast ? 'text-gray-500 cursor-default' : 'text-gray-700 hover:text-blue-500'
                }`}>
                {crumb.label}
              </button>

              {index < currentBreadcrumbs.length - 1 && (
                <div className="px-2 flex flex-col justify-start items-center">
                  <div className="text-gray-300 text-sm font-normal leading-snug">/</div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
};
